<template>
  <div>
    <el-dialog :visible.sync="dialogCodeVisible" top="2%" @close="handleCancel">
      <span slot="title">审核拒绝</span>
      <div class="pass-reject-refuse-box" v-loading="loading">
        <div class="pass-reject-refuse-tip">
          <span style="color: #ff3939">*</span>
          <span>原因</span>
        </div>
        <el-input v-model="reason" placeholder="请输入" size="mini" />
        <div class="pass-reject-refuse-button">
          <el-button size="mini" plain @click="handleCancel">取消</el-button>
          <el-button
            type="primary"
            size="mini"
            :disabled="!reason"
            @click="handleSubmit"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>

    <TipDialog ref="TipDialogRef" @success="handleResetSuccess"></TipDialog>
  </div>
</template>

<script>
import TipDialog from "@/components/TipDialog/index.vue";

export default {
  name: "PassReject",
  components: {
    TipDialog,
  },
  props: {},
  data() {
    return {
      dialogCodeVisible: false,
      loading: false,
      form: {},
      reason: "",
    };
  },
  methods: {
    handleCancel() {
      this.reason = "";
      this.dialogCodeVisible = false;
    },
    handleResetSuccess() {
      this.dialogCodeVisible = false;
      this.$emit("submit");
    },
    async handleSubmit() {
      this.loading = true;
      const { code, message } = await this.$api.prescription.RejectPrescription(
        {
          prescriptionId: this.form.id,
          reason: this.reason,
        }
      );
      this.loading = false;
      if (code === 500) {
        this.$refs.TipDialogRef.show({
          content: message,
        });
        return;
      }
      this.$message({
        message: "审核成功",
        type: "success",
      });
      this.dialogCodeVisible = false;
      this.$emit("submit");
    },
    async show(row) {
      this.dialogCodeVisible = true;
      this.form = row;
    },
  },
};
</script>

<style scoped>
::v-deep .el-dialog__header {
  background: #f7f7f7 !important;
  border-radius: 4px 4px 0px 0px !important;
  border-bottom: 1px solid #dcdcdc !important;
}
</style>
<style lang="scss" scoped>
@import "./passRejectRefuse.scss";
</style>
